
import { api } from "../api";

/**
 * customerUpdateStatusById - Function that updates on database an existing customer status by id  
 * /customers/{id}/{status}  
 * method PUT  
 * @async-function
 */
const customerUpdateStatusById = async (token: string, id: number, status: string) => {
    const response = await api.put(
        `/customers/${id}/${status}`, {}, {
             headers: { 'Authorization': `Bearer ${token}` }
        });
    return response;
};
export default customerUpdateStatusById;
